import styled from 'styled-components';

export default styled.span<{ $back?: boolean }>`
  ${({ theme, $back }) => `
    font-size: 22pt;
    white-space: nowrap;
    overflow: hidden;
    cursor: ${$back ? 'pointer' : 'text'};
    font-weight: 500;
    text-overflow: ellipsis;
    &:before {
      content: ${$back ? '"\\25C0"' : ''};
      color: ${theme.palette.primary.main};
      font-size: ${$back ? '11pt' : '14pt'};
      vertical-align: middle;
      padding-right: ${$back ? '0.4em' : '0.5em'};
      font-weight: bold;
    }
  `}
`;
